// Minimal entry point - required by React dev server to serve /public static files
// The actual site is 100% static HTML in /public/
import React from 'react';
import ReactDOM from 'react-dom/client';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(React.createElement('div'));
